import React, { createContext, useContext, useState } from "react";

export const AppContext = createContext();

export const AppContextProvider = ({ children }) => {
  const [state, setState] = useState({
    isLoggedIn: false,
    isLoading: true,
    user: {},
    dashboardData: {},
    employeeId: null,
    employee: null,
    systemModules: null,
    roleId: null,
    permissions: [],
    resetPassRedirect: false,
    notifsCount: 0,
  });

  return (
    <AppContext.Provider value={{ state, setState }}>
      {children}
    </AppContext.Provider>
  );
};

export const useAppContext = () => {
  const context = useContext(AppContext);
  if (!context) {
    throw new Error("useAppContext must be used within an AppContextProvider");
  }
  return context;
};
